module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GN-132794199d609bec653f93670246e5ef.png";